import React, { useState } from 'react';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate, useLocation } from 'react-router-dom';
import addInitialBlogs from '../utils/addInitialBlogs';
import '../styles/AdminLogin.css';

const AdminLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMessage('');
        setLoading(true);

        try {
            await signInWithEmailAndPassword(auth, email, password);
            const redirectPath = location.state?.from || '/admin/dashboard';

            // Set verification based on context
            if (redirectPath.includes('/blog')) {
                sessionStorage.setItem('blogAccessVerified', 'true');
            } else {
                sessionStorage.setItem('bookingAccessVerified', 'true');
            }

            navigate(redirectPath);
        } catch (err) {
            if (err.code === 'auth/user-not-found') {
                setError('User not found. Click "Setup Admin Account" button below to create the admin user first.');
            } else if (err.code === 'auth/wrong-password') {
                setError('Incorrect password. Please try again.');
            } else if (err.code === 'auth/invalid-email') {
                setError('Invalid email format.');
            } else {
                setError('Login failed. Please check your credentials and try again.');
            }
            console.error('Login error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleSetupAdmin = async () => {
        setError('');
        setSuccessMessage('');
        setLoading(true);

        const adminEmail = 'nyssa7070@gmail.com';
        const adminPassword = 'nyssahealth70@70';

        try {
            await createUserWithEmailAndPassword(auth, adminEmail, adminPassword);
            setSuccessMessage('✅ Admin account created successfully! You can now login with the credentials.');
            setEmail(adminEmail);
            setPassword(adminPassword);
        } catch (err) {
            if (err.code === 'auth/email-already-in-use') {
                setSuccessMessage('✅ Admin account already exists! You can login now.');
                setEmail(adminEmail);
                setPassword(adminPassword);
            } else if (err.code === 'auth/operation-not-allowed') {
                setError('⚠️ Please enable Email/Password authentication in Firebase Console first. Go to Firebase Console → Authentication → Sign-in method → Enable Email/Password');
            } else {
                setError('Error creating admin account: ' + err.message);
            }
            console.error('Setup error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleAddInitialBlogs = async () => {
        setError('');
        setSuccessMessage('');
        setLoading(true);

        try {
            const result = await addInitialBlogs();
            setSuccessMessage(`✅ Successfully added ${result.success} blogs to your website! You can now view them on the /blogs page.`);
        } catch (err) {
            if (err.code === 'permission-denied') {
                setError('⚠️ Please enable Firestore Database first. Go to Firebase Console → Firestore Database → Create Database');
            } else {
                setError('Error adding blogs: ' + err.message);
            }
            console.error('Error adding blogs:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-container">
            <div className="admin-login-card">
                <div className="admin-login-header">
                    <h1>Admin Login</h1>
                    <p>Nyssa Health Admin Panel</p>
                </div>

                <form onSubmit={handleLogin} className="admin-login-form">
                    {error && <div className="error-message">{error}</div>}
                    {successMessage && <div className="success-message">{successMessage}</div>}

                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="login-button"
                        disabled={loading}
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
